import React, { useState, useContext } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { useFormik } from 'formik';
import useFormSubmit from '~/hooks/useFormSubmit';
import * as Yup from 'yup';
import TransContext from '~/contexts/TransContext';

export default function NewsletterSubscribe({ className = '', type = 'light', imgClass = '', formContainerClass = '', formClass = '', inputClass = '', buttonClass = '', buttonLabel = '', hideIcon = false, hideTitle = false }) {
  const trans = useContext(TransContext);

  const [isSubmitted, setIsSubmitted] = useState(false);

  // eslint-disable-next-line
  const { post, loading, response } = useFormSubmit({
    url: '/.netlify/functions/autopilot-form',
    setIsSubmitted
  });

  const formik = useFormik({
    initialValues: {
      contact: {
        Email:''
      }
    },
    validationSchema: Yup.object({
      contact: Yup.object({
        Email: Yup.string().email('Invalid email address').required('Required')
      })
    }),
    onSubmit: async (values) => {
      values.contact.unsubscribed = false;
      values.contact._autopilot_list = '44087410-EF96-4FF8-9233-3F58E1C48AD6';
      await post(values);
    },
  });

  const initialHeading = !hideTitle ? trans.content.newsletterHeading : null
  const heading = !isSubmitted ? initialHeading : trans.content.newsletterConfirmationHeading

  return (
    <div className={`flex flex-wrap md:flex-nowrap items-center -ml-8 ${className}`}>
      {!hideIcon && (
        <div className="pl-8 mb-4 md:mb-0">
          <div className={`w-full max-w-[120px] object-contain ${imgClass} `} >
            {type === 'light' && <StaticImage src="../assets/icons/news-subscribe.png" placeholder="tracedSVG" alt="" />}
            {type === 'dark' && <StaticImage src="../assets/icons/news-subscribe-dark.png" placeholder="tracedSVG" alt="" />}
          </div>
        </div>
      )}
      <div className={`pl-8 flex-auto w-full ${formContainerClass} `}>
        <div className="font-bold mb-[1px]" dangerouslySetInnerHTML={{ __html: heading }} />

        {!isSubmitted && (
          <form
            noValidate
            onSubmit={formik.handleSubmit}
            className={`flex border-b h-10 w-full max-w-[414px] md:w-[414px] group
              ${formik.touched?.contact?.Email && formik.errors?.contact?.Email && 'border-[#ff0000] text-[#ff0000]'}
              ${formClass}
              ${loading && 'pointer-events-none'}
            `}
          >
            <input
              type="email"
              name="contact.Email"
              onChange={formik.handleChange}
              value={formik.values.contact.Email}
              placeholder={trans?.content?.emailPlaceholder}
              className={`flex-auto outline-none bg-transparent ${inputClass}`}
            />
            <button type="submit" className={`pl-4 cursor-pointer group-hover:text-blue transition-color duration-200 ${buttonClass}`} onClick={formik.handleSubmit}>
              <div className="mr-4">{buttonLabel}</div>
              <svg
                className="max-w-[8px] w-full"
                width="8"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-121" fill="white">
                  <path d="M0.811523 12.1753L7.71173 6.49013L0.811523 0.80496" />
                </mask>
                <path
                  d="M7.71173 6.49013L8.66555 7.6478L10.0706 6.49013L8.66555 5.33245L7.71173 6.49013ZM1.76535 13.333L8.66555 7.6478L6.7579 5.33245L-0.142302 11.0176L1.76535 13.333ZM8.66555 5.33245L1.76535 -0.352717L-0.142302 1.96264L6.7579 7.6478L8.66555 5.33245Z"
                  fill="currentColor"
                  mask="url(#path-1-inside-121)"
                />
              </svg>
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
